import axios from "axios";
import employees from "../../models/gestionTiempos/employees";
import attributes from "../../models/gestionTiempos/attributes";
import groups from "../../models/gestionTiempos/groups/groups";
import schedule from "../../models/gestionTiempos/schedules/schedule";
import models from "../../models/gestionTiempos/models";
import filters from "../../models/gestionTiempos/filters";
import controller from "../../models/gestionTiempos/controller";
import controllerRegis from "../../models/gestionTiempos/controllerRegis";
import filterId from "../../models/gestionTiempos/filterId";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getEmployees = () => {
    let token = localStorage.getItem("token");
    let operId = localStorage.getItem("operId");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios
      .get(`${url}/empleados/${operId}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return employees.fromJson(item);
        })
      );
  };
  getAttributes = (date) => {
    let token = localStorage.getItem("token");
    let operId = localStorage.getItem("operId");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios
      .get(`${url}/atributos/${operId}&${date}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return attributes.fromJson(item);
        })
      );
  };
  getGroups = (date) => {
    let token = localStorage.getItem("token");
    let operId = localStorage.getItem("operId");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios
      .get(`${url}/grupos/${operId}&${date}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return groups.fromJson(item);
        })
      );
  };
  getSchedule = (date) => {
    let token = localStorage.getItem("token");
    let operId = localStorage.getItem("operId");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios
      .get(`${url}/horarios/${operId}&${date}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return schedule.fromJson(item);
        })
      );
  };
  getModels = (date) => {
    let token = localStorage.getItem("token");
    let operId = localStorage.getItem("operId");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios
      .get(`${url}/empmodelos/${operId}&${date}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return models.fromJson(item);
        })
      );
  };
  getFilters = () => {
    let token = localStorage.getItem("token");
    let operId = localStorage.getItem("operId");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios
      .get(`${url}/operfiltros/${operId}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return filters.fromJson(item);
        })
      );
  };
  deleteFilters = (id) => {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(`${url}/operfiltros/${id}`, { headers }).then(() => {});
  };
  newFilter = (data) => {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    let dataToSend = {
      operId: data.operId,
      defecto: data.defecto,
      nombre: data.nombre,
      creadoEl: data.creadoEl,
      data: JSON.stringify(data.data),
    };

    return axios.post(`${url}/operfiltros`, dataToSend, { headers });
  };
  newController = (date, filtro, dateTo) => {
    let token = localStorage.getItem("token");
    let operId = localStorage.getItem("operId");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/obtenerNovedades/${operId}&${date}&${dateTo}&${filtro}`, {
        headers,
      })

      .then(({ data }) =>
        data.map((item) => {
          return controller.fromJson(item);
        })
      );
  };

  getRegis(date, filtro, dateTo) {
    let token = localStorage.getItem("token");
    let operId = localStorage.getItem("operId");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/obtenerRegis/${operId}&${date}&${dateTo}&${filtro}`, {
        headers,
      })

      .then(({ data }) =>
        data.map((item) => {
          return controllerRegis.fromJson(item);
        })
      );
  }

  processNovelty = (data) => {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    let payload = {
      empId: data.empId,
      fecha: data.date,
    };

    return axios.post(`${url}/procesarNovedad`, payload, { headers,timeout: 60000 });
  };
  refreshNovelty = (from, filter) => {
    let token = localStorage.getItem("token");
    let operId = localStorage.getItem("operId");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let fromReformat = from.slice(0, 10);
    return axios
      .get(
        `${url}/obtenerNovedades/${operId}&${fromReformat}&${fromReformat}&${filter}`,
        {
          headers,
        }
      )
      .then(({ data }) =>
        data.map((item) => {
          return controller.fromJson(item);
        })
      );
  };
  getShowFilter = (id) => {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/operfiltros/filtro/${id}`, {
        headers,
      })
      .then(({ data }) => {
        return filterId.fromJson(data);
      });
  };
  updatedFilter = (id) => {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const payload = {
      defecto: true,
    };
    return axios.patch(`${url}/operfiltros/${id}`, payload, {
      headers,
    });
  };
}
export default service;
